const TYPES = ({
  // list
  loadingFormSearch: 'LOADING_SEARCH_SETTINGS_GROUP_FORM_TOGGLE',
  searchSuccess: 'SEARCH_SETTINGS_GROUP_SUCCESS',
  searchError: 'SEARCH_SETTINGS_GROUP_LIST_ERROR',

  // form create
  updateItemListingManagerSuccess: 'MANAGER_SETTINGS_GROUP_SUCCESS_UPDATE_LISTING',
  insertItemListingManagerSuccess: 'MANAGER_SETTINGS_GROUP_SUCCESS_INSERT_LISTING',
  deleteItemListingManagerSuccess: 'MANAGER_SETTINGS_GROUP_SUCCESS_DELETE_LISTING',

  // form search
  setDefaultPage: 'SET_SEARCH_SETTINGS_GROUP_DEFAULT_PAGE',
});

export default TYPES;
